
const fullDesignerPlanType = "fullDesigner";
const onlyContactDetailPlanType ="onlyContactDetails"

var initialState =
{
    id: "",
    securityToken: "",
    sent: false,
    changeRows: [],
    planSentPreviously: false,
    hasBench: false,
    hasPaneling: false,
    hasStove: false,
    hasLights: false,
    hasDoor: false,
    sellerId: "",
    resellerId: "",
    requestResellerAssistance: false,
    feedbackSent: false,
    planType: fullDesignerPlanType

}
const plan = (state = initialState, action) => {
    switch (action.type) {
        case 'PLAN_SAVED':
            return Object.assign({}, state, {
                id: action.id ? action.id : state.id,
                securityToken: action.securityToken ? action.securityToken : state.securityToken
            })
        case 'PLAN_SENT':
            return Object.assign({}, state, {
                sent: true
            })
        case 'NEW_PLAN':
            return Object.assign({}, state, {
                sent: false,
                sequrityToken: "",
                id: ""
            })
      case 'PLAN_LOADED':
            return Object.assign({}, state, {
                id: action.plan.id,
                securityToken: action.plan.securityToken,
                sent: action.plan.sent,
                changeRows: action.plan.changeRows,
                planSentPreviously: action.plan.sent,
                hasBench: action.plan.hasBench,
                hasPaneling: action.plan.hasPaneling,
                hasStove: action.plan.hasStove,
                hasLights: action.plan.hasLights,
                hasDoor: action.plan.hasDoor
            })
        case 'CLIENT_COFIGURATION_UPDATED':
            let products = action.configuration.selectableProducts;
            if (products) {
                return Object.assign({}, state, {
                    hasBench: products.hasBench,
                    hasPaneling: products.hasPaneling,
                    hasStove: products.hasStove,
                    hasDoor: products.hasDoor,
                    hasLights: products.hasLights
                })
            }
            else
                return state;
        case 'TOGGLE_BENCH':
            return Object.assign({}, state, {
                hasBench: !state.hasBench
            })
        case 'TOGGLE_STOVE':
            return Object.assign({}, state, {
                hasStove: !state.hasStove
            })
        case 'TOGGLE_DOOR':
            return Object.assign({}, state, {
                hasDoor: !state.hasDoor
            })
        case 'TOGGLE_PANELING':
            return Object.assign({}, state, {
                hasPaneling: !state.hasPaneling
            })
        case 'TOGGLE_LIGHTS':
            return Object.assign({}, state, {
                hasLights: !state.hasLights
            })
        case 'CHANGE_SELLERID':
            return Object.assign({}, state, {
                sellerId: action.sellerId
            })
        case 'SET_RESELLERID':
            return Object.assign({}, state, {
                resellerId: action.resellerId
            })
        case 'RESELLER_ASSISTANCE_CHANGED':
            return Object.assign({}, state, {
                requestResellerAssistance: action.value
            })
        case 'FEEDBACK_SENT':
            return Object.assign({}, state, {
                feedbackSent: true
            })
        case 'SELECT_ONLY_CONTACT_PATH':
            return Object.assign({}, state, {
                planType: onlyContactDetailPlanType
            })
        case 'SELECT_DESIGN_PATH':
            return Object.assign({}, state, {
                planType: fullDesignerPlanType
            })



        default:
            return state;
    }
}
export default plan;


